import { Table } from 'legacy/lut/library/list'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import { Operator } from 'core-components/types'
import { Logic } from 'core-components/types/ICrudHelpers'
import { downloadQbrAttachment } from 'partner360/components/QBR/api/downloadQbrAttachment'
import { selectQBREntryId } from 'partner360/features/QBR'

import { getJbpQbrAttachments } from '../../helpers/getJbpQbrAttachments'
import { IQbrAttachment } from '../../models/qbrAttachment'

import { QBR_ATTACHMENTS_DATA_SOURCE } from './configs'
import { getColumns } from './helpers/getColumns'

export const AttachmentsTable: FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const crud = useMemo(() => getJbpQbrAttachments(), [])
  const documentId = useSelector(selectQBREntryId)

  const deleteAttachment = useCallback(
    async (attachment: IQbrAttachment) => {
      setIsLoading(true)
      await crud.delete(QBR_ATTACHMENTS_DATA_SOURCE, { EntryId: attachment.EntryId })
      setIsLoading(false)
    },
    [crud]
  )

  const downloadAttachment = useCallback(async (attachment: IQbrAttachment) => {
    setIsLoading(true)
    await downloadQbrAttachment({
      uid: attachment.UID,
      formId: 1559,
      fileName: attachment.Name,
      fieldName: 'Name',
    })
    setIsLoading(false)
  }, [])

  const columns = useMemo(() => {
    return getColumns({
      deleteAttachment,
      downloadAttachment,
    })
  }, [deleteAttachment, downloadAttachment])

  useEffect(() => {
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          value: documentId,
          operator: Operator.EQUAL,
          field: 'DocumentId',
        },
      ],
    })
  }, [crud, documentId])

  return (
    <div>
      <LoaderOverlay isVisible={isLoading} />
      <Table header hasTranslate selectedRowClassName="" source={crud} columns={columns} />
    </div>
  )
}
